
var id = "favorite";
var markup = "<symbol viewBox=\"0 0 14 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"favorite\">\n    <title>34. Icons/filled/action/favorite_border_24px</title>\n    <defs>\n        <filter id=\"favorite_filter-1\">\n            <feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 1.000000 0\"></feColorMatrix>\n        </filter>\n        <path d=\"M19,9 L15,9 L15,3 L9,3 L9,9 L5,9 L12,16 L19,9 Z M5,18 L5,20 L19,20 L19,18 L5,18 Z\" id=\"favorite_path-2\" />\n    </defs>\n    <g id=\"favorite_用户画像\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"favorite_标签-数值类-标签人数\" transform=\"translate(-1053.000000, -231.000000)\">\n            <g id=\"favorite_编组-2\" transform=\"translate(600.000000, 144.000000)\">\n                <g id=\"favorite_下载\" transform=\"translate(406.000000, 84.000000)\">\n                    <g id=\"favorite_34.-Icons/filled/action/favorite_border_24px\" transform=\"translate(42.000000, 0.000000)\" filter=\"url(#favorite_filter-1)\">\n                        <g>\n                            <mask id=\"favorite_mask-3\" fill=\"white\">\n                                <use xlink:href=\"#favorite_path-2\" />\n                            </mask>\n                            <use id=\"favorite_icon/file/download_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#favorite_path-2\" />\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
